import { render, staticRenderFns } from "./CategoryReviews.vue?vue&type=template&id=01037396&scoped=true"
import script from "./CategoryReviews.vue?vue&type=script&lang=js"
export * from "./CategoryReviews.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CategoryReviews.vue?vue&type=style&index=1&id=01037396&prod&scoped=true&lang=css"
import style2 from "./CategoryReviews.vue?vue&type=style&index=2&id=01037396&prod&lang=css"
import style3 from "./CategoryReviews.vue?vue&type=style&index=3&id=01037396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01037396",
  null
  
)

export default component.exports